import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  timeNotif: number = 0;
  isActive: EventEmitter<boolean> = new EventEmitter<boolean>();
  type: string;
  textNotif: string = '';

  activeNotif(type: string): void {
    this.setType(type);
    this.isActive.emit(true);
    if (this.timeNotif > 0) {
      this.timer();
    }
  }

  setTimeNotif(value: number): void {
    if (value) {
      this.timeNotif = value;
    }
  }

  timer(): void {
    if (this.timeNotif) {
      setTimeout(() => {
        this.isActive.emit(false);
      }, this.timeNotif);
    }
  }

  disableNotif(): void {
    this.isActive.emit(false);
  }

  clearConfig(): void {
    this.timeNotif = 0;
    this.isActive.emit(false);
  }

  setType(value: string): void {
    this.type = value;
  }

  setText(text: string): void {
    this.textNotif = text;
  }

}
